import React, { useEffect } from 'react';
import { FixedWithContainer } from '../../../common/CardBoardStyled';
import {
  Card,
  CardBody,
  CardTitle,
  CardList,
  CardBodySection,
  CardButton
} from './PaymentOptions.styled';
import iconCreditCard from '../../../../../assets/icons/payments/credit-card.svg';
import iconInfoBlack from '../../../../../assets/icons/payments/infoBlack.svg';
import iconSmartphone from '../../../../../assets/icons/payments/smartphone.svg';
import iconMapPin from '../../../../../assets/icons/payments/mapPin.svg';
import ReusableInfo from '@/presentation/reusables/Info';
import Interbank from '../../../../../assets/icons/payments/Interbank.svg';
import BCP from '../../../../../assets/icons/payments/BCP.svg';
import Scotiabank from '../../../../../assets/icons/payments/Scotiabank.svg';
import BBVA from '../../../../../assets/icons/payments/BBVA.svg';
import { TogglePaymentOptions } from '../../components/TogglePaymentOptions';
import { BankBlock } from '../../components/BankBlock';
import { SubsectionHeader } from '@/presentation/reusables/SectionHeader';
import PaymentContainer from '../../components/ContainerPayments';

interface BalanceProps {
  goBackButton: () => void;
  handlerRedirect: (route: string) => void;
  paymentBanksResults: any;
}

const PaymentOptionsView = (props: BalanceProps) => {
  const { goBackButton, handlerRedirect, paymentBanksResults } = props;

  useEffect(() => {
    document.title = `UTP + Portal | Pagos | Opciones de Pago`;
    return () => {
      document.title = `UTP+ Portal | Universidad Tecnológica del Perú`;
    };
  }, []);

  return (
    <PaymentContainer>
      <FixedWithContainer>
        <div className="payments">
          <SubsectionHeader title="Opciones de pago" onClick={goBackButton} />
          <ReusableInfo
            backgroundColor="#fabd00"
            iconColor="#161D1F"
            style={{ marginTop: '8px', marginBottom: '24px' }}
            text="La universidad <span> no puede realizar cambios en los pagos ya efectuados.</span> Por favor, comprueba cuidadosamente la información y el importe antes de realizar cada transacción."
            textColor="#161D1F"
          />
          <div className="reserve__container">
            <div>
              <p
                style={{
                  fontWeight: 900,
                  fontSize: '16px',
                  lineHeight: '24px',
                  color: '#161D1F'
                }}
              >
                Pago en bancos autorizados
              </p>
              <p
                style={{
                  fontWeight: 400,
                  fontSize: '14px',
                  lineHeight: '20px',
                  marginTop: '8px',
                  color: '#161D1F'
                }}
              >
                Interbank, Scotiabank, BBVA y BCP.
              </p>
              <p style={{ display: 'flex', gap: '12px', marginTop: '4px' }}>
                <img src={Interbank} alt="Interbank" />
                <img src={Scotiabank} alt="Scotiabank" />
                <img src={BBVA} alt="BBVA" />
                <img src={BCP} alt="BCP" />
              </p>
            </div>
            <TogglePaymentOptions
              image={iconSmartphone}
              title="Apps y banca por internet"
              list={[
                { content: 'Descuento pronto pago solo en cuotas.' },
                { content: 'Paga con tarjeta de crédito del mismo banco.' },
                { content: 'Paga sin comisiones.' }
              ]}
              childContent={
                <>
                  <p className="discountInfo">
                    <img src={iconInfoBlack} alt="iconInfo" />
                    <span>
                      El descuento en pronto pago aplica{' '}
                      <b>
                        hasta un día hábil antes de la fecha de vencimiento.
                      </b>
                    </span>
                  </p>

                  {paymentBanksResults?.map((bank: any) => (
                    <BankBlock
                      key={bank.agentCode}
                      name={bank.name}
                      discount={bank.discount}
                      description={bank.description}
                      url={bank.appWebUrl}
                      buttonName="Ir a banca por internet"
                      agentCode={bank.agentCode}
                    />
                  ))}
                </>
              }
            />
            <TogglePaymentOptions
              image={iconMapPin}
              title="Presencial: Agentes o ventanillas"
              list={[
                {
                  title: 'Ventanillas: ',
                  content:
                    'Puede estar sujeto a comisión financiera por parte del banco.'
                },
                {
                  title: 'Agentes: ',
                  content:
                    'Paga sin comisiones en bodegas, tiendas y establecimientos autorizados.'
                },
                { content: 'Descuento pronto pago solo en cuotas.' },
                { content: 'Paga con tarjeta de crédito del mismo banco.' },
                {
                  content:
                    'Además de tu número de DNI o pasaporte, te pueden solicitar el código de pago.'
                }
              ]}
              childContent={
                <>
                  <p className="discountInfo">
                    <img src={iconInfoBlack} alt="iconInfo" />
                    <span>
                      El descuento en pronto pago aplica{' '}
                      <b>
                        hasta un día hábil antes de la fecha de vencimiento.
                      </b>
                    </span>
                  </p>

                  {paymentBanksResults?.map((bank: any) => (
                    <BankBlock
                      key={bank.agentCode}
                      name={bank.name}
                      discount={bank.discount}
                      description={bank.description}
                      url={bank.locationOfChannelsUrl}
                      buttonName="¿Dónde puedo pagar?"
                      agentCode={bank.agentCode}
                      list
                    />
                  ))}
                </>
              }
            />
          </div>
          <div
            className="reserve__container"
            style={{
              marginTop: '32px'
            }}
          >
            <div>
              <p
                style={{
                  fontWeight: 900,
                  fontSize: '16px',
                  lineHeight: '24px',
                  color: '#161D1F'
                }}
              >
                Pago en línea
              </p>
              <p
                style={{
                  fontWeight: 400,
                  fontSize: '14px',
                  lineHeight: '20px',
                  marginTop: '4px',
                  color: '#161D1F'
                }}
              >
                Paga con cualquier tarjeta de crédito de otras entidades
                financieras.
              </p>
            </div>
            <Card>
              <CardBody>
                <CardBodySection>
                  <CardTitle title="Pago en línea con otras tarjetas">
                    <img src={iconCreditCard} alt="iconCreditCard" /> Con otras
                    tarjetas de crédito
                  </CardTitle>
                  <CardList>
                    <li>Sin comisiones.</li>
                    <li>Solo tarjetas de crédito.</li>
                    <li>No aplica descuentos.</li>
                    <li>
                      No incluye tarjetas de BBVA, Interbank, BCP, Scotiabank.
                    </li>
                  </CardList>
                  <CardButton
                    style={{ marginTop: '24px' }}
                    onClick={() =>
                      handlerRedirect(`pagos/opciones-pago/online`)
                    }
                  >
                    Pagar en línea
                  </CardButton>
                </CardBodySection>
              </CardBody>
            </Card>
          </div>
        </div>
      </FixedWithContainer>
    </PaymentContainer>
  );
};

export default PaymentOptionsView;
